/** @jsx isolateComponent */
import { Fragment } from 'react';

import { isolateComponent } from '@zapier/style-encapsulation';
import { Colors, Heading, Typography } from '@zapier/design-system';

import DocLinks from '../../shared/DocLinks';

type GeneralDocsProps = {
  /** General docs to link */
  links: Array<{
    href: string;
    title: string;
  }>;
};

const Styles = {
  title: {
    ...Typography.paragraph1ShortBold,
    color: Colors.gray,
  },
};

/** Renders the list of general docs in `<DocsStep>`. */
const GeneralDocs = ({ links }: GeneralDocsProps) => (
  <Fragment>
    <Heading css={Styles.title}>
      {links.length === 1 ? 'This article' : 'These articles'} may also be
      useful
    </Heading>
    <DocLinks links={links} />
  </Fragment>
);

export default GeneralDocs;
